import iconCoinSmall from '@/assets/images/icons/coin-small.png';
import IconTextUnit from '../../../../components/ui/IconTextUnit/IconTextUnit';
import utilsStyles from '../../../../styles/modules/utils.module.scss';
import { formatCurrency } from '../../../../utils/formatters';
import styles from './PurchaseInventory.module.scss';

type Props = {
  value: string | number;
};

function PurchaseInventory({ value }: Props) {
  return (
    <ul className={styles.purchaseInventory}>
      <li className={styles.inventoryItem}>
        <p className={`${styles.itemName} ${utilsStyles.textBold}`}>利用可能なコイン</p>
        <IconTextUnit
          text={formatCurrency(value)}
          imgSrc={iconCoinSmall.src}
          unit={'coin'}
          isUnitBold
          textSize='xLarge'
          data-testid='user-coin-display'
        />
      </li>
    </ul>
  );
}

export default PurchaseInventory;
